<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <LgFinderPageTipoEstadoConservacao
          id="finderEstadoConservacaoIbpPainelDeConfiguracao"
          v-model="form.estadoConservacao"
          label="Estado de Conservação:"
          required
          :prefix="[prefix + title]"
          :isModal="true"
          @input="handleSelectEstadoConservacao"
        />
      </b-form-group>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import LgFinderPageTipoEstadoConservacao from "@/components/Finders/LgFinderPageTipoEstadoConservacao.vue";

export default {
  components: {
    LgFinderPageTipoEstadoConservacao,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        estadoConservacao: null,
      },
      prefix: "Configuração do Sistema",
      title: "Estado de Conservação",
    };
  },
  methods: {
    handleSelectEstadoConservacao(estado) {
      this.form.estadoConservacao = estado;
    },
    async salvar() {
      if (!this.form.estadoConservacao) {
        this.$bvToast.toast("Selecione um Estado de Conservação", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = this.form.estadoConservacao.id.toString();

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        this.form.estadoConservacao = {
          id: parseInt(this.configuracao.valorPropriedade),
          descricao: this.configuracao.valorPropriedadeLabel,
        };
      }
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
